import React from 'react';
import { MessageCircleIcon, FileTextIcon, ScaleIcon, PhoneIcon, MailIcon } from 'lucide-react';
import { FadeIn } from '../components/FadeIn';
import { PageHero } from '../components/PageHero';
import { CTASection } from '../components/CTASection';
interface KlachtenPageProps {
  onNavigate: (page: string) => void;
}
export function KlachtenPage({
  onNavigate
}: KlachtenPageProps) {
  const stappen = [{
    icon: <MessageCircleIcon className="w-6 h-6 text-gold" data-id="element-589" />,
    title: 'Bespreek het met je adviseur',
    body: 'Ben je ergens niet tevreden over? Neem dan eerst contact met ons op. In de meeste gevallen lossen wij het samen snel en persoonlijk op. Bel ons of stuur een e-mail en leg je klacht kort uit.'
  }, {
    icon: <FileTextIcon className="w-6 h-6 text-gold" data-id="element-590" />,
    title: 'Dien een schriftelijke klacht in',
    body: 'Komen we er samen niet uit? Dien je klacht dan schriftelijk in via info@jdgadvies.nl of per post. Beschrijf zo duidelijk mogelijk waar je klacht over gaat. Wij bevestigen de ontvangst binnen enkele werkdagen en reageren inhoudelijk binnen twee weken.'
  }, {
    icon: <ScaleIcon className="w-6 h-6 text-gold" data-id="element-591" />,
    title: 'Leg je klacht voor aan Kifid',
    body: 'Ben je niet tevreden met onze reactie? Dan kun je je klacht binnen drie maanden voorleggen aan het Klachteninstituut Financiële Dienstverlening (Kifid), waarbij wij zijn aangesloten. De uitspraak van Kifid is voor ons bindend. Meer informatie vind je op kifid.nl.'
  }];
  return <div className="w-full" data-id="element-592">
      <PageHero title="Klachtenprocedure" subtitle="Wij doen ons best om je zo goed mogelijk te helpen. Toch iets niet naar wens? Zo pakken wij een klacht samen op." label="Klachten" data-id="element-593" />

      <section className="py-20 md:py-28 bg-white" data-id="element-594">
        <div className="max-w-3xl mx-auto px-4 md:px-8" data-id="element-595">
          <FadeIn data-id="element-596">
            <div className="space-y-6 text-lg text-gray-600 leading-relaxed mb-12" data-id="element-597">
              <p data-id="element-598">
                Wij hechten veel waarde aan tevreden klanten. Ben je toch niet
                tevreden over onze dienstverlening, dan horen wij dat graag.
                Jouw feedback helpt ons om onze service te verbeteren. Wij
                behandelen elke klacht zorgvuldig en vertrouwelijk.
              </p>
            </div>
          </FadeIn>

          <div className="space-y-6" data-id="element-599">
            {stappen.map((stap, index) => <FadeIn key={index} delay={index * 0.1} className="bg-warm rounded-2xl border border-gray-100 p-6 md:p-8 flex gap-5" data-id="element-600">
                <div className="flex flex-col items-center flex-shrink-0" data-id="element-601">
                  <div className="w-12 h-12 bg-navy rounded-full flex items-center justify-center text-white text-lg font-bold shadow-md" data-id="element-602">
                    {index + 1}
                  </div>
                </div>
                <div data-id="element-603">
                  <div className="flex items-center gap-3 mb-2" data-id="element-604">
                    {stap.icon}
                    <h2 className="text-xl md:text-2xl font-bold text-navy" data-id="element-605">
                      {stap.title}
                    </h2>
                  </div>
                  <p className="text-gray-600 leading-relaxed" data-id="element-606">{stap.body}</p>
                </div>
              </FadeIn>)}
          </div>

          <FadeIn delay={0.3} className="mt-12" data-id="element-607">
            <div className="bg-navy rounded-2xl p-8 text-white" data-id="element-608">
              <h2 className="text-xl font-bold text-gold mb-4" data-id="element-609">
                Waar kun je terecht?
              </h2>
              <div className="space-y-4 text-gray-300 leading-relaxed" data-id="element-610">
                <p data-id="element-611">
                  Je kunt je klacht op de volgende manieren bij ons melden. Wij
                  reageren altijd persoonlijk.
                </p>
                <div className="flex flex-col sm:flex-row gap-4 pt-2" data-id="element-612">
                  <a href="tel:0232052161" className="inline-flex items-center gap-2 text-white font-semibold hover:text-gold transition-colors" data-id="element-613">
                    <PhoneIcon className="w-5 h-5 text-gold" data-id="element-614" />
                    023-205 2161
                  </a>
                  <a href="mailto:info@jdgadvies.nl" className="inline-flex items-center gap-2 text-white font-semibold hover:text-gold transition-colors" data-id="element-615">
                    <MailIcon className="w-5 h-5 text-gold" data-id="element-616" />
                    info@jdgadvies.nl
                  </a>
                </div>
                <p className="text-sm text-gray-400 pt-2" data-id="element-617">
                  JDG Hypotheken | Verzekeringen · Sloterweg 228, 1171 CX
                  Badhoevedorp · Aangesloten bij Kifid · AFM 12051006 · KVK
                  42010917
                </p>
              </div>
            </div>
          </FadeIn>
        </div>
      </section>

      <CTASection title="Liever direct even bellen?" subtitle="Wij lossen de meeste vragen het snelst op in een persoonlijk gesprek." buttonText="Neem contact op" onNavigate={onNavigate} page="contact" variant="light" data-id="element-618" />
    </div>;
}